export default "<div [id]=\"reCaptchaId\"></div>"